export const getHorizontalFile = (...files) => {
	const rightFiles = files.filter(Boolean);
	const horizontalFile = rightFiles.find((file) => file.width > file.height);

	return horizontalFile || rightFiles[0];
};
